import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { mapList, mapRetrieve } from '../common/rest.operators';

import { HierarchyInfo, ManagerReportDataItem, ReportArgs } from './tdcf.model';

@Injectable()
export class TdcfService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    retrieveHierarchyInfo(
        id: number,
        maxDepth: number,
    ): Observable<HierarchyInfo> {
        const params = new HttpParams()
            .set('id', id.toString())
            .set('maxDepth', maxDepth.toString());
        return this._http
            .get(`${this._appConfig.API_ENDPOINTS.FORM}/tdcf/hierarchyInfo`, {
                params,
            })
            .pipe(
                mapRetrieve(),
                catchError(() => of({})),
            );
    }

    generateManagerReport(
        args: ReportArgs,
    ): Observable<ManagerReportDataItem[]> {
        return this._http
            .post(
                `${this._appConfig.API_ENDPOINTS.FORM}/tdcf/managerReport`,
                args,
            )
            .pipe(
                mapList(),
                catchError(() => of([])),
            );
    }
}
